import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { MakeCopy } from 'ui/icons/action/MakeCopy';
import { colors } from 'ui/theme/colors';
import { Popover, PopoverTrigger } from 'ui/popover';
import {
  StyledMetadataList,
  StyledProjectTitle,
  StyledIconButton,
  StyledPopoverContent,
} from './ProjectMetadata.styled';
import { MetadataListItem } from './MetadataListItem';
import { copyMetadata } from './utils';
import { useProjectMetadata } from './useProjectMetadata';

export const METADATA_TRIGGER_TEST_ID = 'project-metadata-trigger';
export const ProjectMetadata = () => {
  const metaData = useProjectMetadata();

  return (
    <Popover>
      <StyledPopoverContent
        TitleContent={
          <StyledProjectTitle>
            Project Details
            <IconButton
              variant={BUTTON_VARIANTS.GHOST}
              size={BUTTON_SIZES.SMALL}
              onClick={() => copyMetadata(metaData)}
            >
              <MakeCopy height={14} width={14} />
            </IconButton>
          </StyledProjectTitle>
        }
        side="bottom"
      >
        <StyledMetadataList>
          {metaData.map((val: string, i: number) => (
            <MetadataListItem key={i} val={val} id={i.toString()} />
          ))}
        </StyledMetadataList>
      </StyledPopoverContent>
      <PopoverTrigger asChild>
        <StyledIconButton
          data-test={METADATA_TRIGGER_TEST_ID}
          variant={BUTTON_VARIANTS.SECONDARY}
          size={BUTTON_SIZES.SMALL}
        >
          <MakeCopy height={24} width={24} color={colors.textPrimary} />
        </StyledIconButton>
      </PopoverTrigger>
    </Popover>
  );
};
